export const TEXT_JUSTIFY_MARKER = '++';
